module.exports = __webpack_public_path__ + "img/jz-pic3.0dc1a3e6.png";